<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

import allegroClient from 'dashboard/api/channel/allegroClient';
import SettingsSubPageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

import { useAlert } from 'dashboard/composables';

const { t } = useI18n();

const channelName = ref('');
const isRequestingAuthorization = ref(false);

const v$ = useVuelidate({ channelName: { required } }, { channelName });

async function requestAuthorization() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  try {
    isRequestingAuthorization.value = true;
    const {
      data: { url },
    } = await allegroClient.generateAuthorization({
      authorization: { name: channelName.value },
    });

    window.location.href = url;
  } catch (error) {
    useAlert(t('INBOX_MGMT.ADD.ALLEGRO_CHANNEL.API.ERROR_MESSAGE'));
  } finally {
    isRequestingAuthorization.value = false;
  }
}
</script>

<template>
  <div
    class="border border-n-weak bg-n-solid-1 rounded-t-lg border-b-0 h-full w-full p-6 col-span-6 overflow-auto"
  >
    <SettingsSubPageHeader
      :header-title="$t('INBOX_MGMT.ADD.ALLEGRO_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.ALLEGRO_CHANNEL.DESC')"
    />
    <form
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="requestAuthorization"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.ALLEGRO_CHANNEL.CHANNEL_NAME.LABEL') }}
          <input
            v-model="channelName"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.ALLEGRO_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
            "
            @blur="v$.channelName.$touch"
          />
          <span v-if="v$.channelName.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.ALLEGRO_CHANNEL.CHANNEL_NAME.ERROR') }}
          </span>
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.ALLEGRO_CHANNEL.CHANNEL_NAME.SUBTITLE') }}
        </p>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="isRequestingAuthorization"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.ALLEGRO_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
